<app-spinner></app-spinner>
<!-- Wrapper-->
<div id="wrapper">
  <mat-sidenav #sidenav mode="side" opened *ngIf="usuarioAutenticado">
    <navigation></navigation>
  </mat-sidenav>
  <!-- Main page wrapper -->
  <div id="page-wrapper" class="gray-bg" [ngClass]="{'login': usuarioAutenticado == false}">
    <!-- Top navigation -->
    <topnavbar *ngIf="usuarioAutenticado"></topnavbar>

    <!-- Main view/routes wrapper-->
    <router-outlet></router-outlet>

    <!-- Footer -->
    <!--<footer></footer>-->

  </div>
  <!-- End page wrapper-->

</div>
<!-- End wrapper-->
